export const slidingWindowSlice = <T>(
  data: T[],
  diagnosticImageIndex?: number,
) => {
  return data;
  // here can be a code that allows to prepare data for slider, e.g. slice some items starting from a diagnostic image
};
